module.exports = __webpack_public_path__ + "img/draw-start.d144d782.png";